import React from 'react';
import WithAdditionalValidationState from 'components/WithAdditionalValidation/WithAdditionalValidationState';
import InputFields from './components/InputFields/InputFields';
import style from './Form.module.scss';

const Form: React.FC = () => {
	return (
		<div className={style.container} data-test="Form">
			<WithAdditionalValidationState>
				<InputFields />
			</WithAdditionalValidationState>
		</div>
	);
};

export default Form;
